<template>

  <div>
    <div
      class="list-form"
      v-sortable="{ handle: '.sortable-move', items: questions}">
      <div
        class="card"
        v-for="(question, questionIndex) in questions"
        :key="questionIndex">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <div class="mr-auto"><a href="javascript:void(0)" class="sortable-move"><i class="fas fa-arrows-alt" /></a></div>
            <div class="pr-3"><input type="checkbox" id="inlineFormCheck" v-model="question.required"> {{ $t('Required') }}</div>
            <div><a href="javascript:void(0)" @click="removeQuestion(questionIndex)">{{ $t('Remove') }}</a></div>
          </div>
        </div>
        <div class="card-body">
          <TemplateapplyFormQuestionsItem
            v-model="questions[questionIndex]"
            :questionIndex="questionIndex"
            :validateErrors="validateErrors" />
        </div>
      </div>
    </div>
    <ValidateMessage :error="validateErrors['application_questions']" />

    <div>
      <a
        href="javascript:void(0)"
        @click="addQuestion()">{{ $t('Add question') }}</a>
    </div>
  </div>

</template>

<script>
import TemplateapplyFormQuestionsItem from './TemplateapplyFormQuestionsItem'

export default {
  name: 'TemplateapplyForm',
  components: {
    TemplateapplyFormQuestionsItem
  },
  props: {
    value: {
      type: Array,
      default: () => ({})
    },
    validateErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      questions: this.value ? [ ...this.value ] : []
    }
  },
  computed: {
  },
  watch: {
    value (newValue) {
      if (JSON.stringify(newValue) === JSON.stringify(this.questions)) {
        return
      }
      this.questions = newValue ? [ ...newValue ] : []
    },
    questions (newValue) {
      this.$emit('input', newValue)
    }
  },
  created () {
  },
  methods: {
    addQuestion () {
      this.questions.push({
        type: 'text',
        label: '',
        required: false,
        options: []
      })
    },
    removeQuestion (index) {
      this.questions.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Templateapply/TemplateapplyFormQuestions.vue